// extracted by mini-css-extract-plugin
export var calendarView = "_is-0";